module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("7")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Saturday Afternoon")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Are you sure you want to do this?” Ginger looked over at Harrie while waiting for the red light to turn green.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie knew she’d been too quiet since they’d left the restaurant. While eating lunch, they talked about the drones and their new ham radio friends. But Harrie remained unwilling to discuss the thing most occupying their minds—last night’s dream, and today’s visit to Petroglyphs National Monument.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was there to say? She didn’t know why the dream came to her, the identity of the deceased person, or how he or she became deceased. As usual, Harrie had only the sketchiest of information, yet a strong sense of urgency.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have no choice,” she said. “Without more information, or understanding why I dreamed about this event, I don’t know where else to start.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger turned the car onto Unser Boulevard. “Have you thought about the reason you receive these dreams?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. The first one, when I was a teenager, freaked me out. I didn’t know where it came from or why it happened to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you became accustomed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie shrugged. “More or less. I’m not sure I’ll ever really be accustomed to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger persisted. “With your other dreams, once we discovered a connection, you solved the mystery, and the dreams stopped.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s your point?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It seems obvious. Isn’t it reasonable to discuss this one with DJ, or even Swannie, before we embark on our own investigation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie shook her head. “I don’t view a visit to the Petroglyphs as being an investigation. I meant it when I said I’ve always wanted to check it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure the body at the Petroglyphs is the same one you saw in your dreams?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Harrie thought a moment. “No, and I won’t be unless I find something at the Petroglyphs tying it in with my dream. I had a huge reaction when Nick Ellis told his story, but I can’t know if ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("what I’m seeing is what he saw—not until I visit there.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger remained quiet a few minutes. “Maybe you could just explain it that way to DJ. If you made him see your reason for getting involved, maybe he wouldn’t be set on keeping you away from the action.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie snorted. “Yeah, right. I have a big picture of that. You’ve seen how much effort DJ makes to prevent me from getting answers. To him, it’s about keeping me safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger nodded. “I know, and to you, it’s about understanding the dreams and solving the mystery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad you see my point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what’s the answer? How do you satisfy your need to know and still keep DJ from having anxiety about your safety?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie shrugged. “If I knew the answer to that, I could start my own advice column.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen minutes later, they turned onto Western Trails, the road leading to the Visitor Center at Petroglyphs National Monument. They parked at the bottom of the hill and noticed two pathways. One on the right led to the building that housed the Visitor Center and several other trails leading to the stone art. The longer pathway to the left climbed a slight hill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie’s skin tingled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s see where this leads us,” she said, and walked toward the left path.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?” Ginger hurried to join her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sense it’s important,” Harrie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naturally.” Ginger shifted her purse to her left shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They arrived at the amphitheater at the end of the path. It looked ready for use. A graceful roof used canvas sails for shade and sheltering visitors. The structure seemed perfect for small groups or individuals to sit and enjoy the quiet in the peaceful atmosphere. It was a simple, yet elegant semi-circular design. Stone pillars of simulated granite, pockmarked with small stones, stood at intervals wide enough to allow a breath-taking view of the landscape to the east.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("In the first milliseconds, it reminded Harrie of photos she’d seen of the ancient Grecian amphitheaters, with their tiered stone seating, and their view of the stage at the bottom. One could almost imagine a performer standing in the pit below the benches, playing ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("to an admiring audience. They would gaze down at him while he strummed a lute.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The overall impression promoted an air of peace and tranquility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But not for Harrie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her imaginary audience would not see the crumpled body that Harrie now pictured in her own head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moments after she had stepped into the structure, she knew—this was the source of her latest dream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only thing missing was the crumpled, lifeless body.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75090600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter07.vue
// module id = 90
// module chunks = 0